import React from 'react'
import { FlowRequestModalFooter, FlowRequestModalText } from './style'
import Button from '../Button'
import { FormattedMessage } from 'react-intl'

const WarnFlowRequestModal = ({ cancelHandler, text, rejectBtnText = 'cancel' }) => {

  // const confirmOnClick = () => {
  //   confirmHandler(item, { isApproved: approve })
  // }

  return (
    <>
      <FlowRequestModalText data-testid='test-request-modal-text'>
        {text}
      </FlowRequestModalText>
      <FlowRequestModalFooter>
        <Button onClick={cancelHandler} type='secondary' dataTest='cancel'>
          <FormattedMessage id={rejectBtnText} />
        </Button>
        {/* <Button onClick={confirmOnClick} type={approve ? 'primary' : 'destructive'} dataTest='confirm'>
          <FormattedMessage id={confirmBtnText} />
        </Button> */}
      </FlowRequestModalFooter>
    </>
  )
}

export default WarnFlowRequestModal
